<template>
  <center>
    <div class="container">
      <Header pageTitle="Manage Tooltips" class="card-container"></Header>
      <el-divider class="divider-green"></el-divider>
      <div class="row">
        <el-card class="box-card" shadow="always">
        <div class="col-sm-12">
          <el-table
            :data="tooltips"
            :default-sort="{ prop: 'phase', order: 'ascending' }"
            empty-text="No ToolTips to display"
            border
            fit
            class="document-table"
          >
            <el-table-column width="60" type="index"> 
            </el-table-column>
            <el-table-column
              min-width="190"
              prop="name"
              label="Tool-tip Name"
            ></el-table-column>
          
      <el-table-column label="Phase" min-width="180"  prop="phase">
            <editable-cell
            :show-input="row.editMode"
                slot-scope="{ row }"
                v-model="row.phase"
              >
                <span slot="content">{{
                  row.phase != "null" ? row.phase : ""
                }}</span>
        </editable-cell>
      </el-table-column>
      <el-table-column label="Description" min-width="180">
            <editable-cell
            :show-input="row.editMode"
                slot-scope="{ row }"
                v-model="row.description"
                :inputType="'textarea'"
              >
                <span slot="content">{{
                  row.description != "null" ? row.description : ""
                }}</span>
        </editable-cell>
      </el-table-column>
            <el-table-column label="Operations" min-width="190">
              <template slot-scope="{ row, index }">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Edit ToolTip"
                  placement="top-start"
                >
                  <el-button
                    size="mini"
                    :class="
                      row.editMode ? 'btn-primary' : 'btn-secondary'
                    "
                    :icon="row.editMode ? 'el-icon-check' : 'el-icon-edit'"
                    @click="handleSave(row, index)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                v-show="row.editMode"
                  class="item"
                  effect="dark"
                  content="Cancel Edit"
                  placement="top-start"
                >
                  <el-button
                    size="mini"
                   
                    class="btn-secondary editing"
                    @click="handleCancel(row, index)"
                  >X</el-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  v-show="!row.editMode"
                  effect="dark"
                  :content="row.status ? 'Click to Hide' : 'Click to Show'"
                  placement="top-start"
                >
                  <el-button
                   
                    size="mini"
                    
                    :class="
                      row.status ? 'btn-primary ' : 'btn-secondary editing  '
                    "
                    :icon="row.status ? 'el-icon-close ': 'el-icon-check'"
                    @click="handleDelete(row, index)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      </div>
    </div>
  </center>
</template>


<script>
import Header from "@/components/App/Header";
import { mapState, mapActions, mapGetters } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import { BaseButton, EditableCell } from "@/components";

import {
  Table,
  TableColumn,
  Upload,
  Button,
  Tag,
  Select,
  Option,
  Alert,
  Form,
  FormItem,
  CheckboxGroup,
  Checkbox,
  Divider,
  Tooltip,
  Card,
} from "element-ui";

export default {
  name: "ToolTipDashboard",
    components: {
    [Card.name]: Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Upload.name]: Upload,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [Alert.name]: Alert,
    [Tag.name]: Tag,
    [Form.name]: Form,
    [Tooltip.name]: Tooltip,
    [FormItem.name]: FormItem,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Divider.name]: Divider,
    EditableCell,
    Treeselect,
    Header,
  },
  data() {
    return{
    }

  },
  mounted() {
    this.getToolTip();
  },
  computed:  {
    ...mapGetters({
      tooltips :'tooltip/tooltips'
    })},
  methods: {...mapActions({
      getToolTip: "tooltip/getToolTips",
      saveToolTip: "tooltip/saveTooltip",
      deleteTooltip: "tooltip/deleteTooltip"
    }),
        handleCancel(row, index) {
      row.editMode = false;
    },
    handleDelete(row, index){
      if(row){
        this.deleteTooltip(row).then(()=>{
          this.getToolTip();
        })
      }
    },
    handleSave(row, index){
    if (row.editMode) {
        // Row Updating Section
        row.editMode = false;
        this.saveToolTip(row).then(() => {
          this.getToolTip();
        })
      }else{
        row.editMode = true;
      }
},   
  },
}
</script>

<style>
.divider-green {
  background-color: #10b45a;
}
.el-button.editing {
  color: #fff;
  border-color: red;
  background-color: red;
}
</style>